export default __webpack_public_path__ + "static/media/new_directory3.550106da.png";